import { API_RESPONSE } from 'eva-fe-sdk-types';
import CrudConsumer from './index';
import Endpoint from '../lib/Endpoint';
import { SDKRequestInit } from '../lib/ApiFetch';

class Providers extends CrudConsumer {
  getAll = (config: SDKRequestInit) => {
    const url: string = Endpoint.getProviders(this.productType);
    return this.apiFetch.get<API_RESPONSE.Providers['200']>(url, config);
  };

  getOne = (providerId: string, config: SDKRequestInit) => {
    const url: string = Endpoint.getProvider(this.productType, providerId);
    return this.apiFetch.get<API_RESPONSE.Provider['200']>(url, config);
  };

  getMany = (config: SDKRequestInit) => {
    const url: string = Endpoint.getProvidersByIds();
    return this.apiFetch.get<API_RESPONSE.ProviderIds['200']>(url, config);
  };
}

export default Providers;
